import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";
import getAxiosInstance from "./../../Utils/axios";
import { DateTime } from "luxon";
import { getUsers } from "./../../Utils/api";
import ShowScreens from "../../Components/ShowScreens";
import MediaPreview from "../../Components/MediaPreview";
import ScreenShow from "../../Components/ScreenShow";
import DateSelector from "../../Components/DateSelector";
import ShowScreenDetails from "../../Components/ShowScreenDetails";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export default function UserLog() {
  const [campaigns, setUserLog] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchFilter, setSearchFilter] = useState("");
  const [searchByType, setSearchByType] = useState("");
  const [limit, setLimit] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalUserLog, setTotalUserLog] = useState(0);
  const [fromTime, setFromTime] = useState("");
  const [tillTime, setTillTime] = useState("");
  const [isClick, setIsClick] = useState(false);

  const [user, setUser] = useState(null);
  const [inputUser, setInputUser] = useState("");

  const fetchUserData = () => getUsers(inputUser);
  useEffect(() => {
    console.log("vvvv==.....>>>>", campaigns);
  });
  const getUserLog = (from, till) => {
    let jsonData = {
      limit: limit,
      page: pageNumber * limit,
      search: searchFilter,
      filter_by: searchByType,
      from: fromTime,
      till: tillTime,
      user: user ? user._id : "",
    };
    // converting (json --> form-urlencoded)

    const data = Object.keys(jsonData)
      .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
      .join("&");

    getAxiosInstance()
      .post("/admin/campaigns-1", data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        setIsLoading(false);
        if (res.data.status === "success") {
          // console.log(res.data.result);
          setTotalUserLog(res.data.totalCount);
          setUserLog(res.data.result);
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot process request" });
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getUserLog("", "");
  }, [limit, pageNumber, searchByType, user, isClick]);

  const changePage = ({ selected }) => setPageNumber(selected);

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-sm-6">
                <h1 className="m-0">User Log Report</h1>
              </div>
            </div>
            <div className="row justify-content-center mt-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">
                      <DateSelector
                        action={() => setIsClick(!isClick)}
                        from={setFromTime}
                        to={setTillTime}
                      />
                    </h3>
                    <div class="card-tools row">
                      <div className="col-12">
                        <AsyncSelect
                          defaultOptions
                          isClearable={true}
                          cacheOption
                          placeholder="Select User"
                          value={user}
                          getOptionLabel={(e) =>
                            `${e.first_name} ${e.last_name}`
                          }
                          getOptionValue={(e) => e._id}
                          loadOptions={fetchUserData}
                          onInputChange={setInputUser}
                          onChange={setUser}
                        />
                      </div>
                      {/* <div className="col-6">
                                                <div className="input-group input-group-sm my-auto" style={{ width: "100%" }}>
                                                    <input type="text" name="table_search" className="form-control float-right" placeholder="Search" value={searchFilter} onChange={(e) => setSearchFilter(e.target.value)} />
                                                    <div className="input-group-append">
                                                        <button type="submit" className="btn btn-default" onClick={() => getUserLog("", "")}>
                                                            <i className="fas fa-search" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div> */}
                    </div>
                  </div>
                  <div className="card-body">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: 10 }}>SL No.</th>
                          <th>User </th>
                          <th>User ID</th>
                          <th>Campaign </th>
                          <th>Media</th>
                          {/* <th>Created On</th> */}
                          <th>Date and Time</th>
                          <th>Screen(s)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={10}>Loading User Log ...</td>
                          </tr>
                        )}
                        {!isLoading && totalUserLog === 0 && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={10}>No User Log Found</td>
                          </tr>
                        )}

                        {campaigns?.map((campaign, i) => (
                          <tr key={i}>
                            <td>{i + 1}.</td>
                            <td>
                              {campaign.user?.first_name}{" "}
                              {campaign.user?.last_name}
                            </td>
                            <td>{campaign.user?.employee_code}</td>
                            <td>
                              <ScreenShow
                                campaign={campaign}
                                Toast={Toast}
                                getAxiosInstance={getAxiosInstance}
                                screenCount={campaign.screens.length}
                                showCampaign={true}
                              />
                            </td>
                            <td>
                              <MediaPreview
                                type={campaign.media?.type}
                                text={campaign.media?.text}
                                images={campaign.media?.image}
                                video={campaign.media?.video}
                              />
                            </td>
                            {/* <td>{DateTime.fromISO(campaign.created_date).toFormat("dd LLL yyyy")}</td> */}

                            {campaign.status === "schedule" ? (
                              <td>
                                {DateTime.fromMillis(
                                  new Date(campaign.start_time).getTime()
                                ).toFormat("dd LLL yyyy h:mm a")}{" "}
                                {/* -{" "}
                                {DateTime.fromMillis(
                                  new Date(campaign.end_time).getTime()
                                ).toFormat("dd LLL yyyy h:mm a")} */}
                              </td>
                            ) : (
                              //   <td>
                              //     {DateTime.fromMillis(
                              //       campaign.start_time
                              //     ).toFormat("dd LLL yyyy h:mm a")}{" "}
                              //     -{" "}
                              //     {DateTime.fromMillis(
                              //       campaign.end_time
                              //     ).toFormat("dd LLL yyyy h:mm a")}
                              //   </td>
                              <td>
                                {/* {DateTime.fromMillis(
                                  campaign.start_time
                                ).toFormat("dd LLL yyyy h:mm a")} */}

                                {DateTime.fromMillis(
                                  new Date(campaign.created_date).getTime()
                                ).toFormat("dd LLL yyyy h:mm a")}
                              </td>
                            )}

                            <td>
                              {/* <ScreenShow
                                campaign={campaign}
                                Toast={Toast}
                                getAxiosInstance={getAxiosInstance}
                                screenCount={campaign.screens.length}
                              /> */}
                              {/* <ShowScreenDetails
                                // campaign={campaign}
                                screen={campaign.screens[0]}
                                Toast={Toast}
                                getAxiosInstance={getAxiosInstance}
                                // screenCount={campaign.screens.length}
                              /> */}
                              <ShowScreens screens={campaign.screens} />
                            </td>
                            {/* <td>{campaign._id}</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix">
                    {totalUserLog > limit ? (
                      <ReactPaginate
                        previousLabel={"«"}
                        nextLabel={"»"}
                        pageCount={Math.ceil(totalUserLog / limit)}
                        onPageChange={changePage}
                        containerClassName={
                          "pagination pagination-sm m-0 float-right"
                        }
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        // previousClassName={"previous"}
                        previousLinkClassName={"page-link"}
                        // nextClassName={"next"}
                        nextLinkClassName={"page-link"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
